module.exports = __webpack_public_path__ + "img/tileable-beam-START.169ceb9a.png";